import { HttpClient } from "@/app/api/HttpClient"
import { API_PREFIX_CAMPAIGN_SUBSCRIBERS_PATH, API_PREFIX_CAMPAIGNS_PATH } from "@/constants/prefix-path-api"
import { t } from "@/languages/i18n"
import { message } from "@/lib/config/lib/antd-global"
import { CampaignSubscriberFilterValues, CampaignSubscriberPayload, FilterSearchParams } from "@/types/types"

type CampaignSubscriberQueryParams = Omit<FilterSearchParams, "populate" | "fields"> & {
  fields?: string[]
  populate?: string | Record<string, any>
}

interface CampaignSubscriberQueryConfig {
  fields?: string[]
  populate?: string | Record<string, any> | null
}

export const fetchCampaignSubscribers = async (
  searchTerms: CampaignSubscriberFilterValues = {},
  queryConfig: CampaignSubscriberQueryConfig = {},
) => {
  const params: CampaignSubscriberQueryParams = {
    populate: "*",
    sort: "createdAt:desc",
    filters: {},
    pagination: {
      withCount: true,
    },
  }

  if (queryConfig.fields?.length) {
    params.fields = queryConfig.fields
  }

  if (queryConfig.populate !== undefined) {
    if (queryConfig.populate === null) {
      delete params.populate
    } else {
      params.populate = queryConfig.populate
    }
  }

  const excludedKeys = ["current", "pageSize", "start", "limit", "total", "page", "sort", "fields", "populate"]

  Object.entries(searchTerms).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return

    if (key === "sort") {
      params.sort = String(value)
    } else if (excludedKeys.includes(key) && (key === "page" || key === "pageSize")) {
      // Handle pagination keys
      params.pagination = {
        ...params.pagination,
        [key]: String(value),
      }
    } else if (!excludedKeys.includes(key)) {
      const filters = params.filters as Record<string, any>

      if (key === "campaign[id][$eq]") {
        filters["campaign"] = { id: { $eq: value } }
      } else {
        filters[key] = { $containsi: String(value) }
      }
    }
  })

  // Set default pageSize if not provided
  if (!params.pagination) {
    params.pagination = { withCount: true }
  }
  if (!params.pagination.pageSize) {
    params.pagination.pageSize = "20"
  }

  try {
    const response = await HttpClient.get(`${API_PREFIX_CAMPAIGN_SUBSCRIBERS_PATH}`, { params ,skipDomainFilter:true},)
    return {
      data: response.data,
      meta: response.meta,
    }
  } catch (error) {
    message.error(t("Lỗi khi tải danh sách đối tác chiến dịch. Vui lòng thử lại."))
    throw error
  }
}

export const fetchCampaignSubscriberId = async (id: number) => {
  try {
    const response = await HttpClient.get(`${API_PREFIX_CAMPAIGN_SUBSCRIBERS_PATH}/${id}?populate=*`,{skipDomainFilter:true})
    return response.data
  } catch (error) {
    message.error(t("Lỗi khi tải thông tin đối tác chiến dịch. Vui lòng thử lại."))
    throw error
  }
}

export const deleteCampaignSubscriber = async (id: number) => {
  try {
    return await HttpClient.delete(`${API_PREFIX_CAMPAIGN_SUBSCRIBERS_PATH}/${id}`,{skipDomainFilter:true})
  } catch (error) {
    message.error(t("Lỗi khi xóa đối tác chiến dịch. Vui lòng thử lại."))
    throw error
  }
}

export const updateCampaignSubscriber = async (id: number, data: CampaignSubscriberPayload) => {
  try {
    return await HttpClient.put(`${API_PREFIX_CAMPAIGN_SUBSCRIBERS_PATH}/${id}`, data,{skipDomainFilter:true})
  } catch (error) {
    message.error(t("Lỗi khi cập nhật đối tác chiến dịch. Vui lòng thử lại."))
    throw error
  }
}

export const addCampaignSubscriber = async (data: CampaignSubscriberPayload) => {
  try {
    return await HttpClient.post(`${API_PREFIX_CAMPAIGN_SUBSCRIBERS_PATH}`, data,{skipDomainFilter:true})
  } catch (error) {
    message.error(t("Lỗi khi thêm đối tác chiến dịch. Vui lòng thử lại."))
    throw error
  }
}

export const fetchCampaigns = async () => {
  try {
    const response = await HttpClient.get(`${API_PREFIX_CAMPAIGNS_PATH}?pagination[pageSize]=100&sort=name:asc`,{skipDomainFilter:true})
    return response.data
  } catch (error) {
    message.error(t("Lỗi khi tải danh sách chiến dịch. Vui lòng thử lại."))
    throw error
  }
}
